{
    "name": "Cinnamon Cap Mushroom",
    "binomial_name": "Hypholoma sublateritium",
    "common_names": [
        "Cinnamon cap",
        "brick top"
    ],
    "description": "Cinnamon Caps are small, orange to pinkish mushrooms with flaky caps. They have a nutty, earthy flavor and crunchy texture. They are delicious saut\u00e9ed, grilled, baked or roasted. Cinnamon Caps grow quickly and abundantly in clusters on large wood substrates or inoculated logs.",
    "sun_requirements": "",
    "sowing_method": "Inoculate log or wood substrate with spores",
    "spread": 0,
    "row_spacing": 0,
    "height": 0,
    "growing_degree_days": 0,
    "companions": [],
    "image": "/crops/images/cinnamon-cap-mushroom.jpg",
    "icon": "/crops/icons/cinnamon-cap-mushroom.avif"
}